import React from 'react'
import css from './style.scss'
import cn from 'classnames'
import {StatTitle, NumberBox} from './utils'

import {n} from 'shared/numbers'

class GeneralSection extends React.Component{
  constructor(props){
    super(props)
    this.state={
      storiesNumber:0,
      storiesRatio:1.3
    }
  }

  loadStats=(props)=>{
    let storiesNumber=props.stories.length
    let daysSpan = props.endDate.startOf("day").diff(props.startDate.startOf("day"), "days") + 1
    let storiesRatio=storiesNumber > 0 ? (storiesNumber / daysSpan).toFixed(2) : "-"
    this.setState({storiesNumber, storiesRatio})
  }
  componentDidMount(){
    this.loadStats(this.props)
  }
  componentWillReceiveProps(props){
    this.loadStats(props)
  }

  render(){
    return (
      <div className={cn(this.props.className, css.statsBox)}>
        <StatTitle>General</StatTitle>
        <div>
          <p>Number of stories in this time frame</p>
          <div className={css.generalContainer}>
            <NumberBox className={css.generalBox} title="Stories">{n(this.state.storiesNumber)}</NumberBox>
            <NumberBox className={css.generalBox} title="Stories/day" description="">{this.state.storiesRatio}</NumberBox>
          </div>
        </div>
      </div>
    )
  }
}

export default GeneralSection;



// WEBPACK FOOTER //
// ./src/components/account_page/stats/sections/general.js